import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["attributes"],
    _excluded2 = ["attributes"];
import { trace } from '@opentelemetry/api';
export var tracingDefaults = {
  applicationName: 'unknown',
  beaconEndpoint: undefined,
  rumAccessToken: undefined
};

var TracingBase = /*#__PURE__*/function () {
  function TracingBase(config) {
    _classCallCheck(this, TracingBase);

    _defineProperty(this, "options", void 0);

    _defineProperty(this, "startActiveSpan", void 0);

    _defineProperty(this, "startSpan", void 0);

    this.options = _objectSpread(_objectSpread({}, tracingDefaults), config);
    var tracer = this.getTracer();
    this.startActiveSpan = tracer.startActiveSpan.bind(tracer);
    this.startSpan = tracer.startSpan.bind(tracer);
  }

  _createClass(TracingBase, [{
    key: "getTracer",
    value: function getTracer() {
      return trace.getTracer(this.options.applicationName);
    }
  }, {
    key: "startActiveWorkflowSpan",
    value: function startActiveWorkflowSpan(name) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          attributes = _ref.attributes,
          options = _objectWithoutProperties(_ref, _excluded);

      var fn = arguments.length > 2 ? arguments[2] : undefined;

      var attributesWithWorkflow = _objectSpread({
        'workflow.name': name
      }, attributes);

      return this.startActiveSpan(name, _objectSpread(_objectSpread({}, options), {}, {
        attributes: attributesWithWorkflow
      }), fn);
    }
  }, {
    key: "startWorkflowSpan",
    value: function startWorkflowSpan(name) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          attributes = _ref2.attributes,
          options = _objectWithoutProperties(_ref2, _excluded2);

      var context = arguments.length > 2 ? arguments[2] : undefined;

      var attributesWithWorkflow = _objectSpread({
        'workflow.name': name
      }, attributes);

      return this.startSpan(name, _objectSpread(_objectSpread({}, options), {}, {
        attributes: attributesWithWorkflow
      }), context);
    }
  }]);

  return TracingBase;
}();

export { TracingBase as default };